/** Browser fetch() failures when the RPC never returns a response body. */
export function isBrowserFetchError(error: unknown): boolean {
    if (!(error instanceof TypeError)) return false;
    const message = error.message;
    return message === 'Failed to fetch'
        || message === 'NetworkError when attempting to fetch resource.';
}

export async function retryOnFetchError<T>(
    run: () => Promise<T>,
    opts: { attempts?: number; delayMs?: number } = {},
): Promise<T> {
    const attempts = opts.attempts ?? 3;
    const delayMs = opts.delayMs ?? 300;
    let lastError: unknown;

    for (let attempt = 0; attempt < attempts; attempt += 1) {
        try {
            return await run();
        } catch (error) {
            lastError = error;
            const isLast = attempt === attempts - 1;
            if (!isBrowserFetchError(error) || isLast) throw error;
            await new Promise((resolve) => {
                window.setTimeout(resolve, delayMs * (attempt + 1));
            });
        }
    }

    throw lastError;
}
